import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { IonInfiniteScroll, RefresherCustomEvent } from '@ionic/angular';
import { Fetchable, Paginated } from '@bling-fe/shared/repositories';

@Component({
  selector: 'bl-infinite-pagination[data]',
  templateUrl: './ui-infinite-pagination.component.html',
  styles: ``,
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false
})
export class UiInfinitePaginationComponent<T, E> implements OnChanges {
  @Input({ required: true }) data!: Fetchable<Paginated<T>, E>;
  @Output() fetchNext = new EventEmitter<void>();
  @Output() refreshPage = new EventEmitter<HTMLIonRefresherElement>();
  @ViewChild('postsInfiniteScroll') postsInfiniteScroll?: IonInfiniteScroll;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['data']) {
      const curr = changes?.['data'].currentValue as Fetchable<Paginated<T>, E>;

      if (this.postsInfiniteScroll) {
        // disabling/enabling loader when all pages loaded
        if ((curr.data?.current_page ?? 0) >= (curr?.data?.total_pages ?? 0)) {
          this.postsInfiniteScroll.disabled = true;
        } else {
          this.postsInfiniteScroll.disabled = false;
        }

        // let loader know that next page loaded
        if (curr.state === 'ready' || curr.state === 'error') {
          this.postsInfiniteScroll.complete();
        }
      }
    }
  }

  public handleInfiniteLoad() {
    this.fetchNext.emit();
  }

  doRefresh(target: RefresherCustomEvent['target'] | undefined) {
    if (target) {
      this.refreshPage.emit(target);
    }
  }
}
